import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { FormErrorMessage } from "../../components";
import { ApiSchemaAddReforwardingVendor, Option } from "../../models";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  vendorOptions: Option[];
  isVendorOptionsLoading?: boolean;
  initialVendorId?: string;
  companyName?: string;
  onSubmitHandler: (form: ApiSchemaAddReforwardingVendor) => void;
  companyId: string;
  vendorId: string;
};

export function ModalVendorReforwardingVendor(props: Props): JSX.Element {
  const {
    show,
    handleShow,
    vendorOptions,
    isVendorOptionsLoading,
    initialVendorId,
    companyName,
    onSubmitHandler,
    companyId,
    vendorId,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm<ApiSchemaAddReforwardingVendor>({
    defaultValues: {
      companyId,
      vendorId,
      reforwardingVendorId: initialVendorId ?? "",
    },
  });

  useEffect(() => {
    reset({
      companyId,
      vendorId,
      reforwardingVendorId: initialVendorId ?? "",
    });
  }, [companyId, vendorId, initialVendorId, reset, show]);

  const defaultOption =
    vendorOptions.find((option) => option.value === initialVendorId) ?? null;

  return (
    <Modal show={show} onHide={() => handleShow(false)} centered>
      {/*@ts-ignore */}
      <Modal.Header closeButton>
        <Modal.Title>Reforwarding Vendor</Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit(onSubmitHandler)}>
        <Modal.Body>
          {companyName && (
            <p className="mb-3">
              Company: <span className="ghost-pill">{companyName}</span>
            </p>
          )}
          <div className="form-group">
            <label htmlFor="" className="position-relative required">
              Vendor
            </label>
            <input type="text" {...register("companyId")} className="d-none" />
            <input type="text" {...register("vendorId")} className="d-none" />
            <input
              type="text"
              {...register("reforwardingVendorId", { required: true })}
              className="d-none"
            />
            <Select
              className={`${
                errors.reforwardingVendorId?.type === "required"
                  ? "field-required"
                  : ""
              }`}
              placeholder="Select vendor"
              isLoading={isVendorOptionsLoading}
              components={{
                IndicatorSeparator: () => null,
              }}
              defaultValue={defaultOption}
              options={vendorOptions}
              onChange={(value) => {
                setValue("reforwardingVendorId", value?.value, {
                  shouldValidate: true,
                });
              }}
            />
            {errors.reforwardingVendorId && (
              <FormErrorMessage message="required" />
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-link text-site text-uppercase"
            onClick={() => handleShow(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary text-uppercase reforwarding-vendor-submit-btn"
          >
            Save
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
